import { CellContext } from '@tanstack/react-table';
import { Device } from '@/types/device.types';

// TODO: Remove this once we have a proper type for the object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceSerialNumberCell = (info: CellContext<Device, any>) => {
  const value = info.getValue();
  return <span>{value ? String(value).toUpperCase() : ''}</span>;
};
